export default () => ({
  loading: false,
  loadingSafetyTimeout: null,

  init() {
    this.listenCalculatorLoading();
  },

  listenCalculatorLoading() {
    window.addEventListener('calculator-started-loading', () => {
      this.loading = true;
      if (this.loadingSafetyTimeout) {
        clearTimeout(this.loadingSafetyTimeout);
      }
      this.loadingSafetyTimeout = setTimeout(() => {
        this.loading = false;
        this.loadingSafetyTimeout = null;
      }, 25000);
    });

    window.addEventListener('calculator-finished-loading', () => {
      this.loading = false;
      if (this.loadingSafetyTimeout) {
        clearTimeout(this.loadingSafetyTimeout);
        this.loadingSafetyTimeout = null;
      }
    });
  },
});
